import { render, staticRenderFns } from "./auditGhzxBgbx.vue?vue&type=template&id=792f78b8&scoped=true&"
import script from "./auditGhzxBgbx.vue?vue&type=script&lang=js&"
export * from "./auditGhzxBgbx.vue?vue&type=script&lang=js&"
import style0 from "./auditGhzxBgbx.vue?vue&type=style&index=0&id=792f78b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f78b8",
  null
  
)

export default component.exports